import React from "react";
import { Button, Tag, Typography } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { getColumnSortOrder, readableDateTime } from "../utilities/helper";
import CopyText from "../components/CopyText";
import TimeAgo from "../components/TimeAgo";

const { Text } = Typography;

export const isCouponExpired = (record) =>
  !record.is_never_expire &&
  !!record.expiry_time_in_ms &&
  Number(record.expiry_time_in_ms) < Date.now();

/**
 * COUPON CODE TABLE
 */
export const couponCodeTable = (onEdit, sort = null) => [
  {
    title: "Name",
    key: "name",
    dataIndex: "name",
  },
  {
    title: "Coupon Code",
    key: "coupon_code",
    dataIndex: "coupon_code",
    className: "col-mono",
    render: (item) => (
      <CopyText value={item} strong>
        {item}
      </CopyText>
    ),
  },
  {
    title: "Expired",
    key: "expired",
    render: (_, record) =>
      isCouponExpired(record) ? (
        <Tag color="error">Yes</Tag>
      ) : (
        <Tag color="success">No</Tag>
      ),
  },
  {
    title: "Status",
    key: "status",
    dataIndex: "is_active",
    render: (item) => (
      <Tag color={item ? "success" : "error"}>
        {item ? "Active" : "Deleted"}
      </Tag>
    ),
  },
  {
    title: "Auto Expire",
    key: "auto_expire",
    dataIndex: "is_never_expire",
    responsive: ["md"],
    render: (item) => <Text>{item ? "No" : "Yes"}</Text>,
  },
  {
    title: "Expiry Time",
    key: "expiry_time_in_ms",
    className: "col-date",
    dataIndex: "expiry_time_in_ms",
    render: (item, record) =>
      !record.is_never_expire && item
        ? readableDateTime(Number(item), "dd/mm/yyyy hh:mm")
        : "--",
  },
  {
    title: "Created Time",
    key: "created_at",
    className: "col-date",
    // Sorted on the server (see CouponCodes component)
    sorter: true,
    sortOrder: getColumnSortOrder(sort, "created_at"),
    sortDirections: ["ascend", "descend"],
    dataIndex: "created_at",
    render: (item) => <TimeAgo value={item} />,
  },
  {
    title: "Updated Time",
    key: "updated_at",
    className: "col-date",
    dataIndex: "updated_at",
    responsive: ["md"],
    render: (item) => <TimeAgo value={item} />,
  },
  {
    title: "Action",
    key: "action",
    align: "right",
    className: "col-actions",
    fixed: "right",
    render: (_, record) => (
      <Button
        type="primary"
        icon={<EditOutlined />}
        onClick={() => onEdit(record)}
      >
        Edit
      </Button>
    ),
  },
];
